import { useQuery } from '@tanstack/react-query';

import { TutorsRepository, UsersRepository } from '@didaskill/domain/data/repositories';
import type { TutorViewFull } from '@didaskill/domain/users/types';
import { cachePresets, type UseQueryParams } from '@didaskill/types/web';

import http from '../../../services/http/api';

const usersRepository = new UsersRepository(http);
const tutorsRepository = new TutorsRepository(http);

export const useUser = (useQueryParams?: UseQueryParams<TutorViewFull>) =>
  useQuery({
    queryKey: ['user'],
    queryFn: () => usersRepository.getCurrentUser(),
    ...useQueryParams,
    ...cachePresets.short,
  });

export const useTutorFeedbackCampaigns = (
  useQueryParams?: UseQueryParams<
    Awaited<ReturnType<TutorsRepository['getTutorFeedbackCampaigns']>>
  >,
) =>
  useQuery({
    queryKey: ['tutor-feedback-campaigns'],
    queryFn: () => tutorsRepository.getTutorFeedbackCampaigns(),
    throwOnError: false,
    ...useQueryParams,
    ...cachePresets.daily,
  });
